import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [isDark] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const auth = getAuth();
      await createUserWithEmailAndPassword(auth, email, password);
      navigate('/'); // Redirect to home or dashboard after successful registration
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div
      className={`relative flex items-center justify-center min-h-screen dark transition-colors duration-300 ${isDark ? 'dark' : ''}`}
      style={{
        background: 'linear-gradient(to bottom, #1f2937, #000)',
        zIndex: 0,
      }}
    >
      {/* Grid Pattern Overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: -1,
          pointerEvents: 'none',
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.2) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.2) 1px, transparent 1px)
          `,
          backgroundSize: '20px 20px',
          opacity: 0.15,
          WebkitMaskImage: `
            linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%),
            linear-gradient(to bottom, black 0%, black 5%, transparent 100%)
          `,
          maskImage: `
            linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%),
            linear-gradient(to bottom, black 0%, black 0%, transparent 100%)
          `,
          WebkitMaskComposite: 'destination-in',
          maskComposite: 'intersect',
        }}
      />

      <div className="w-full max-w-md bg-gray-800/50 rounded-xl shadow-lg ring-1 ring-white/10 p-8">
        <div className="text-center mb-8">
          <span className="text-3xl font-bold animate-gradient-text bg-clip-text text-transparent select-none">
            Toolip
          </span>
          <h2 className="mt-4 text-2xl font-semibold text-white">
            Create Your Account
          </h2>
          <p className="text-gray-300">
            Sign up to start using Toolip
          </p>
        </div>

        <form onSubmit={handleRegister} className="space-y-6">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
              {error}
            </div>
          )}

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-700 text-white"
              placeholder="Enter your email"
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-700 text-white"
              placeholder="Create a password"
            />
          </div>

          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              Confirm Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-700 text-white"
              placeholder="Confirm your password"
            />
          </div>

          <button 
            type="submit" 
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition-colors duration-200"
          >
            Sign Up
          </button>

          <div className="text-center mt-4">
            <p className="text-sm text-gray-300">
              Already have an account? 
              <Link
                to="/LoginPage"
                className="text-blue-400 hover:underline ml-1"
              >
                Login
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
